import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BusinessListState, businessesFeatureKey } from '../reducers/businesses.reducer';
import * as fromBusinessesReducer from '../reducers';
import * as fromBusinessesListReducer from '../reducers/businesses.reducer';

//#region BUSINESSES ROOT STATE
export const getBusinessesState = createFeatureSelector<fromBusinessesReducer.State, BusinessListState>(
  fromBusinessesReducer.businessesFeatureKey
);
//#endregion

//#region CHECK LIST OF BUSINEESES SUB STATE
export const getBusinessesListState = createSelector(getBusinessesState, state => state[businessesFeatureKey]);

export const getSelectedBusinesses = createSelector(getBusinessesListState, fromBusinessesListReducer.getSelectedBusiness);

export const selectSelectedBusinessesId = createSelector(getBusinessesListState, fromBusinessesListReducer.getSelectedBusinessId);
